import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "title p-grid  p-jc-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "p-col-6" }, " Contenido ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "p-col-4 p-text-right" }, " RTG: ", -1)
const _hoisted_4 = { class: "content p-grid" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "desc p-col-5 p-text-left" }, " Ultima semana ", -1)
const _hoisted_6 = {
  class: /*#__PURE__*/_normalizeClass([
              'title p-col-3 p-text-right'
            ])
}
const _hoisted_7 = { class: "p-col-1" }
const _hoisted_8 = {
  key: 0,
  class: "indicator pi pi-caret-down"
}
const _hoisted_9 = {
  key: 1,
  class: "indicator pi pi-caret-up"
}
const _hoisted_10 = {
  key: 2,
  class: /*#__PURE__*/_normalizeClass([
              'title p-col-3 p-text-right'
            ])
}
const _hoisted_11 = { class: "p-grid" }
const _hoisted_12 = { class: "p-col-12 p-text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Divider = _resolveComponent("Divider")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, {
    class: "ch-card chart-card h100",
    id: "PerformanceInfo"
  }, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _createElementVNode("div", {
          class: _normalizeClass([
              'p-col-2',
              $props.value >= 4.7 ? 'positive-rate' : 'negative-rate'
            ])
        }, _toDisplayString(isNaN($props.value) ? 0 : $setup.truncate($props.value)), 3),
        _createVNode(_component_Divider, { class: "divider" })
      ])
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", {
          class: _normalizeClass([
              'title p-col-3 p-text-right',
              $props.lastValue >= 4.7 ? 'positive-rate' : 'negative-rate'
            ])
        }, _toDisplayString(isNaN($props.lastValue) ? 0 : $setup.truncate($props.lastValue)), 3),
        _createElementVNode("div", _hoisted_6, _toDisplayString(isNaN($props.variation) ? 0 : $setup.truncate($props.variation)), 1),
        _createElementVNode("div", _hoisted_7, [
          ($props.variation < 0)
            ? (_openBlock(), _createElementBlock("i", _hoisted_8))
            : ($props.variation > 0)
              ? (_openBlock(), _createElementBlock("i", _hoisted_9))
              : (_openBlock(), _createElementBlock("div", _hoisted_10))
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_Button, {
            label: "Versión 5",
            class: "version5-button p-button p-button-outlined"
          })
        ])
      ])
    ]),
    _: 1
  }))
}